<template>
  <div class="login-container">
    <div class="login-form">
      <div class="card card-login">
        <div class="card-header">
          <a href="#" class="logo-link">
            <img src="@/assets/img/logo_jtb_wht@2x.png" alt="Logo" />
          </a>
          <div class="text-login">{{ $t("general.system_name") }}</div>
        </div>
          <div class="card-body">
            <div class="form-box">
              <div class="text-center mt-1">
                <!--テキスト-->
                <div v-html="$t('login.pc_input_code_message')"></div>
              </div>

              <div class="text-center d-flex justify-content-center mt-3" v-if="url">
                <!--QR表示-->
                <vue-qrcode :value="url" :options="{ scale: 6 }" />
              </div>

              <!--戻る次へボタン-->
              <div class="mt-3 d-flex">
                <button class="btn btn-pink-53 w-100" @click="next()">
                  {{ $t("button.next") }}
                </button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

import VueQrcode from '@chenfengyuan/vue-qrcode';
import StorageService from "@/services/common/storage.service";
import { Role } from "@/helpers/role";
import store from '../../../../store';
import router from '../../../../router';

export default {
  name: "PcLoginMfa",

  components: {
    VueQrcode,
  },

  data() {
    return {
      errorMessage: "",
      username: "",
      placeId: "",
      clickChangePass: false,
    };
  },

  beforeMount () {
      let token = StorageService.getToken();
      if (token) {
          const role = StorageService.getUserRole();
          if (role == Role.PwReset.id) {
              router.push("/admin/users");
          } else {
              router.push("/");
          }
      }
      let remember = JSON.parse(StorageService.getRememberMe());
      if (remember) {
          this.username = remember.username;
          this.password = remember.password;
          // this.placeId = remember.placeId;
          this.rememberMe = remember.rememberMe;
      }
  },

  mounted() {
    this.username = this.$route.query.username;
    this.placeId = this.$route.query.placeId;
    this.clickChangePass = StorageService.getClickChangePass();
    let isExpired = StorageService.getExpired();
    if (isExpired) {
        this.errorMessage = this.$root.$t("error.error_expired");
        StorageService.removeExpired();
    }
  },

  created() {
    store.state.url ? '' : router.push("/");
  },

  methods: {
    next() {
      router.push({path: '/login/mfa', query: {username: this.username, placeId: this.placeId}});
    },
  },

  computed: {
    url() {
      return store.state.url
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/components/pc/Login/LoginFirstMfa.vue